/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Dla kogo jest płatność.
 */

export const SettlementPaymentRecipientDto = {
    Igor: 'IGOR',
    Robert: 'ROBERT',
} as const;

export type SettlementPaymentRecipientDto = typeof SettlementPaymentRecipientDto[keyof typeof SettlementPaymentRecipientDto];



